import { Capacitor } from '@capacitor/core'
import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import { client_routes } from './routes/client'
import { admin_routes } from './routes/admin'
import { useAuthGlobalStore } from '@/stores/authGlobalStore'

const isNativeApp =
  import.meta.env.VITE_CAPACITOR === 'true' || Capacitor.isNativePlatform()

const router = createRouter({
  history: isNativeApp
    ? createWebHashHistory(import.meta.env.BASE_URL)
    : createWebHistory(import.meta.env.BASE_URL),
  // route level code-splitting
  // this generates a separate chunk (About.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  routes: [
    {
      path: '/',
      name: 'restoHome',
      component: () => import('@/views/HomeView.vue'),
      meta: { title: 'Home' }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/AboutView.vue')
    },
    ...client_routes,
    ...admin_routes,
    //END: end admin views
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('@/views/NotFoundView.vue')
    },
    {
      path: '/error-page',
      name: 'error',
      component: () => import('@/views/ErrorView.vue')
    },
    {
      path: '/sampleChart',
      name: 'sampleChart',
      component: () => import('@/views/sampleChart/sampleChartView.vue')
    }
  ]
})

// Navigation guard to check permissions
router.beforeEach((to, from, next) => {
  const authStore = useAuthGlobalStore()
  
  // Check if route requires permission
  if (to.meta.permission) {
    let hasAccess = false
    const permission = to.meta.permission
    const permissionMatch = to.meta.permissionMatch || 'any' // Default to 'any' if not specified
    
    // Handle single permission (string)
    if (typeof permission === 'string') {
      hasAccess = authStore.hasPermission(permission)
    } 
    // Handle multiple permissions (array)
    else if (Array.isArray(permission)) {
      if (permissionMatch === 'all') {
        // User must have ALL permissions
        hasAccess = authStore.hasAllPermissions(permission)
      } else {
        // User must have ANY of the permissions (default)
        hasAccess = authStore.hasAnyPermission(permission)
      }
    }
    
    // If user doesn't have required permission(s), redirect
    if (!hasAccess) {
      const isClientRoute = to.path.startsWith('/client/')
      // If user doesn't have permission and route has resto_id, redirect to the matching panel resto home
      if (to.params.resto_id) {
        next({
          name: isClientRoute ? 'clientRestoHome' : 'adminRestoHome',
          params: { resto_id: to.params.resto_id }
        })
        return
      }
      next({ name: isClientRoute ? 'clientDashboard' : 'adminDashboard' })
      return
    }
  }
  
  // If no permission required or user has permission, proceed
  next()
})

export default router
